/**
 * @Event 将一个数组根据指定的数字变成一个二维数组（二维数组中的每个数组的长度都是指定的数字）
 * @param {Array} arr 需要处理的数组
 * @param {Number} num 指定的数字
 * @author: mhf
 * @time: 2024-01-07 13:27:34
 **/
export default function makeNumArr(arr, num) {
  const chunks = [];
  let currentIndex = 0;
  while (currentIndex < arr.length) {
    chunks.push(arr.slice(currentIndex, currentIndex + num));
    currentIndex += num;
  }
  return chunks;
}
